// Export factory functions and methods

export { equals } from "./equals.js";
export { from } from "./from.js";

// Export type definitions
export type {
	StorageProofLike,
	StorageProofType,
} from "./StorageProofType.js";
